import { Event, LiveStatus } from "@gp/models";

export function buildHistoryEventDefaults() {
	return {
		betBuilder: false,
		bettingStatus: 1,
		hasLiveCoverage: false,
		hasTvCoverage: false,
		liveChange: "",
		liveStatus: LiveStatus.PREMATCH,
		isLive: false,
		isLocked: false,
		isOutright: false,
		matchStatus: "",
		stopReason: "",
		note: "",
		isTopEvent: false,
		isUpcoming: false,
	} satisfies Partial<Event>;
}
